import { createSelector } from 'reselect';
import { sumAggregates } from 'services/Calculation';
import {
  applyPerformanceFilters,
  createTimeRangeFromFilter,
  formatDateRange
} from './PerformancePageUtils';
import { getAccounts } from '../account/AccountSelectors';
import {
  ACTIVITY_SUMMARY_FILTER_TYPE,
  getInceptionDateForFilterType
} from './PerformancePageSelectors';
import { getPortfolioAsOfDate } from 'state/portfolio/PortfolioSelectors';
import {doesObjectPropertyNotHaveValue} from 'services/Formats';

export const getActivitySummaryFilter = (state) => state.activitySummary;
const getHistory = (state) => state.history || [];
const getPerformancePage = (state) => state.performancePage;

export const getActivitySummaryData = createSelector(
  getPerformancePage,
  getActivitySummaryFilter,
  getHistory,
  (performancePage, activitySummaryFilter, history) => {
    const filteredAggregates = applyPerformanceFilters(
      performancePage,
      activitySummaryFilter,
      history
    );

    return sumAggregates(filteredAggregates);
  }
);

export const getAccountsForActivitySummary = createSelector(
  getPerformancePage,
  getActivitySummaryFilter,
  getAccounts,
  (performancePage, activitySummaryFilter, accounts) => {
    return applyPerformanceFilters(
      performancePage,
      activitySummaryFilter,
      accounts
    );
  }
);

export const getInceptionDateForActivitySummary = createSelector(
  [
    (state) =>
      getInceptionDateForFilterType(state, ACTIVITY_SUMMARY_FILTER_TYPE),
    (state) => getPortfolioAsOfDate(state)
  ],
  (inceptionDate, portfolioAsOfDate) =>
    inceptionDate ? inceptionDate : portfolioAsOfDate
);

export const getDateRangeFilterForActivitySummary = createSelector(
  getActivitySummaryFilter,
  (performanceFilter) => performanceFilter.dateRangeFilter
);

export const getDateRangeForActivitySummary = createSelector(
  getInceptionDateForActivitySummary,
  getDateRangeFilterForActivitySummary,
  getPortfolioAsOfDate,
  (inceptionDate, dateRangeFilter, portfolioAsOfDate) =>
    createTimeRangeFromFilter(inceptionDate, dateRangeFilter, portfolioAsOfDate)
);

export const getFormattedDateRangeForActivitySummary = createSelector(
  getDateRangeForActivitySummary,
  (dateRange) => formatDateRange(dateRange)
);

export const getActivitySummaryFilterIsNull = createSelector(
  getActivitySummaryFilter,
  (activitySummaryFilter) => doesObjectPropertyNotHaveValue(activitySummaryFilter.dateRangeFilter) && activitySummaryFilter.dateRangeFilter.custom === true
);